import { CSSProperties } from 'react';

// NA-5596: design spec caps truncation tooltips at a 250px max-width,
// applied via antd's own `overlayStyle` (targets `.ant-tooltip`) rather than
// a CSS Module class. Shared by the Approval Drawer's `TooltipCell.tsx` and
// `invoiceTransactionColumns.tsx` (Table layout, default and custom columns)
// so the value can't drift between them. Kept under the generic
// `components/constants`, not `CardTable`, since `CardTable` is slated to
// move into `ap-frontend-common` and other features shouldn't import from it.
export const TRUNCATION_TOOLTIP_OVERLAY_STYLE: CSSProperties = {
  maxWidth: 250,
};
